import React, { useContext } from "react";
import { View, Text, StyleSheet, Pressable } from "react-native";

import {
  BG_STYLES,
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  Label,
  LazyImage,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { useTranslation } from "react-i18next";

interface Props {
  cropName: string;
  cropImageUrl: string | null;
  sowingDate: string | null;
  stage: string | null;
  status: string;
  statusStyles: any;
  onClick?: () => void;
  transplantedDate?: string | null;
}

const CropCard = ({
  cropImageUrl,
  cropName,
  sowingDate,
  stage,
  status,
  statusStyles,
  onClick,
  transplantedDate,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Pressable
      style={[
        COMMON_STYLES.b1,
        BORDER_STYLES.borderNeutral10,
        COMMON_STYLES.p1,
        BG_STYLES.bgNeutral00,
        COMMON_STYLES.br1,
        COMMON_STYLES.row,
        COMMON_STYLES.relative,
        styles.ml42,
        {
          display: "flex",
          flexDirection: "row",
          width: 300,
        },
      ]}
      onPress={() => onClick?.()}
    >
      <View style={[COMMON_STYLES.flex1, styles.ml42]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING3,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral100,
            { maxWidth: 165 },
          ]}
        >
          {cropName}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral80,
            COMMON_STYLES["mt1/2"],
          ]}
        >
          {transplantedDate ? t("transplantation") : t("sowing")} :
          {transplantedDate || sowingDate || "-"}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral80,
            COMMON_STYLES["mt1/2"],
          ]}
        >
          {t("stage")}: {stage || " -"}
        </Text>
      </View>
      <View
        style={[
          COMMON_STYLES["ml0.5"],
          { position: "absolute", right: 10, top: 10 },
        ]}
      >
        <Label
          text={status}
          bgColor="bgSuccess100"
          textColor="textWhite"
          containerStyle={[COMMON_STYLES["br1/4"], statusStyles]}
        />
      </View>
      <LazyImage
        imageUrl={cropImageUrl}
        imgStyles={styles.cropImage}
        fallBackIcon={
          <View style={[styles.cropImage, styles.noImage]}>
            <Text style={styles.noImgTextOverImg}>{cropName[0]}</Text>
          </View>
        }
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  ml42: {
    marginLeft: 42,
  },
  cropImage: {
    position: "absolute",
    height: 84,
    width: 84,
    borderRadius: 42,
    borderWidth: 1,
    borderColor: COLORS.neutral10,
    left: -42,
    top: 21,
    zIndex: 1,
    backgroundColor: COLORS.white,
    resizeMode: "contain",
  },
  noImage: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.white,
  },
  noImgTextOverImg: {
    fontSize: 36,
    lineHeight: 40,
    fontWeight: "600",
    color: COLORS.black,
  },
});

export default CropCard;
